module.exports = __webpack_public_path__ + "assets/img/risen-logo.ccbb5bf4.png";